import {Order} from "src/components/Order/Order";

const Layout = () => {
   return (
     <>
       <Order />
     </>
   )
}
export default Layout